import React from 'react';
import { isMobile } from 'utils/common';
import s from './s.module.less';
import { INVITED_ONBOARDING_STEPS } from '../../constants';
import { EInvitedOnboardingStep } from '../../types';

interface ProcessBarProps {
    currentStep: EInvitedOnboardingStep;
}

const ProcessBar: React.FC<ProcessBarProps> = ({ currentStep }) => {
    const currentStepConfig = INVITED_ONBOARDING_STEPS.find((item) => item.key === currentStep);
    const currentOrder = currentStepConfig?.order ?? 1;
    const mobile = isMobile();

    if (mobile && currentStepConfig) {
        return (
            <div className={s.wrap}>
                <div className={`${s.item} ${s.active}`}>
                    <span className={s.indicator}>{currentStepConfig.order}</span>
                    <span className={s.title}>{currentStepConfig.title}</span>
                </div>
            </div>
        );
    }

    return (
        <div className={s.wrap}>
            {INVITED_ONBOARDING_STEPS.map((step, index) => {
                const isActive = step.order === currentOrder;
                const isDone = step.order < currentOrder;
                return (
                    <React.Fragment key={step.key}>
                        <div className={`${s.item} ${isActive ? s.active : ''} ${isDone ? s.done : ''}`}>
                            <span className={s.indicator}>{step.order}</span>
                            <span className={s.title}>{step.title}</span>
                        </div>
                        {index < INVITED_ONBOARDING_STEPS.length - 1 && <span className={s.divider} />}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default ProcessBar;
